<div class="horizinns-container hosts-home-container center">
    <img src="/assets/images/logo_full_900.png" style="width:40%;" class="main-logo" alt="Horizinns logo"/>
    <mat-card class="hosts-home-card horizinns-card mw-60">
        <mat-card-content class="content">
            <h1>WHY HOSTS CHOOSE HORIZINNS?</h1>
            <h2>
                More Control. Less Cost.
            </h2>
        </mat-card-content>
    </mat-card>
    <div class="scroll-down">
        <i class="fas fa-chevron-down"></i>
    </div>
</div>

<section id="hosts" class="hosts-section">
    <div class="container">
        <div class="hosts-grid">
            
            <div class="hosts-content">
                <h2>Why Hosts Choose Horizinns</h2>
                <h3>More Control. Less Cost.</h3>
                
                <h4>Save Money</h4>
                <ul>
                    <li><i class="fas fa-check"></i> $300 flat annual fee per property</li>
                    <li><i class="fas fa-check"></i> Zero fees per booking — keep 100% of your rental income</li>
                </ul>

                <h4>Stay in Control</h4>
                <ul>
                    <li><i class="fas fa-check"></i> Update listings, calendars, and pricing in real time</li>
                    <li><i class="fas fa-check"></i> Communicate directly with renters — no middleman</li>
                    <li><i class="fas fa-check"></i> Set your own house rules, minimum stays, and requirements</li>
                </ul>

                <h4>Flexible Platform</h4>
                <ul>
                    <li><i class="fas fa-check"></i> List on <strong>HORIZINNS</strong> and keep your properties active on Airbnb, Vrbo, etc.</li>
                    <li><i class="fas fa-check"></i> Perfect for individual homeowners or professional managers</li>
                </ul>
            </div>

            <div class="hosts-visuals">
                <div class="col-2-heading">COMPARE THE DIFFERENCE</div>
                
                <table class="comparison-table">
                    <thead>
                        <tr>
                            <th>Feature</th>
                            <th>HORIZINNS</th>
                            <th>Other Platforms</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Host Fee</td>
                            <td>$300/year flat</td>
                            <td>3-15% per booking</td>
                        </tr>
                        <tr>
                            <td>Renter Fee</td>
                            <td>$0</td>
                            <td>Up to 14% service fee</td>
                        </tr>
                        <tr>
                            <td>Profit</td>
                            <td>100% of rate</td>
                            <td>Reduced by dual fees</td>
                        </tr>
                        <tr>
                            <td>Control</td>
                            <td>Full</td>
                            <td>Limited by rules</td>
                        </tr>
                    </tbody>
                </table>

                <div class="renter-benefit-card">
                    <h3>Renter Benefits</h3>
                    <ul>
                        <li><i class="fas fa-user-friends"></i> Contact hosts directly for custom requests</li>
                        <li><i class="fas fa-ban"></i> No booking fees, no service charges</li>
                        <li><i class="fas fa-map-marker-alt"></i> New U.S. listings added daily</li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</section>



